// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fbKd","buttons":"styles_buttons__30cms"};